export default [
    {
        name: 'cadastro-funcionalidade',
        path: 'funcionalidade',
        redirect: 'funcionalidade/index',
        component: () => import(/* webpackChunkName: 'cadastro-funcionalidade' */ '@/views/cadastro/funcionalidade/Index'),
        children: [
            {
                meta: {title: 'Lista de funcionalidades'},
                name: 'cadastro-funcionalidade-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'cadastro-funcionalidade' */ '@/views/cadastro/funcionalidade/List.vue'),
            },
            {
                meta: {title: 'Edição de funcionalidade'},
                name: 'cadastro-funcionalidade-edit',
                path: 'edit/:id',
                props: route => ({id: parseInt(route.params.id)}),
                component: () => import(/* webpackChunkName: 'cadastro-funcionalidade' */ '@/views/cadastro/funcionalidade/Form.vue'),
            },
        ],
    },
]